import { Divider } from "../../components/Divider";
import { TROK0 } from "./TROK0";
import construction from 'url:../../assets/pardon-our-dust.png';

export function TROKL() {
    return <div className='trok-main-width v-box gap-32'>
        <div className='trok-main'>
            <h3>This Page is Lost.</h3>
            <h3>Hopefully You Can Find It.</h3>
            <br />
            <Divider />
            <br />
            <img src={construction} width='100%' className="trok-box" />
            <br />
            <Divider />
            <br />
        </div>
    </div>
}